import { contactCompat } from '@/services/customerApiCompat'

export const getContact = contactCompat.getContact
